import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import { api } from "@/api";
import QRCode from "qrcode";

const ClaimPage = () => {
  const { t } = useTranslation();
  const { code } = useParams();
  const [info, setInfo] = useState(null);
  const [qr, setQr] = useState(null);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(true);
  const [savingWallet, setSavingWallet] = useState(false);
  const [walletError, setWalletError] = useState("");

  useEffect(() => {
    (async () => {
      try {
        const r = await api.publicClaim(code);
        setInfo(r);
        const redeemUrl = `${window.location.origin}/redeem/${r.code}`;
        const dataUrl = await QRCode.toDataURL(redeemUrl, {
          margin: 1,
          scale: 6,
          errorCorrectionLevel: "M",
        });
        setQr({ dataUrl, redeemUrl });
      } catch (e) {
        setError(e.message || t('public.scan.error') || t('public.verify.error') || 'Fehler');
      } finally {
        setLoading(false);
      }
    })();
  }, [code]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-muted px-4">
      <div className="bg-background p-6 rounded shadow w-full max-w-md text-center space-y-4">
        <h1 className="text-lg font-semibold">{t('public.claim.title')}</h1>
        {loading && <p className="text-sm">{t('common.loading')}</p>}
        {error && <p className="text-sm text-red-600">{error}</p>}
        {info && !error && (
          <>
            <div className="text-sm break-all">
              <strong>{info.code}</strong>
              <br />
              {t('public.claim.discount')}: {info.discountType} {info.discountValue}
            </div>
            {qr && (
              <div className="space-y-2">
                <img
                  src={qr.dataUrl}
                  alt="QR"
                  className="mx-auto border p-1 bg-background"
                />
                <button
                  type="button"
                  onClick={() => navigator.clipboard.writeText(qr.redeemUrl)}
                  className="underline text-blue-600 text-xs"
                >
                  {t('public.claim.copyLink')}
                </button>
              </div>
            )}
            <div className="pt-2">
              <button
                type="button"
                disabled={savingWallet}
                className="text-xs bg-green-600 text-white px-3 py-1 rounded"
                onClick={async () => {
                  try {
                    setWalletError("");
                    setSavingWallet(true);
                    const resp = await api.walletGoogleCreate(info.codeId || info.id || info.code);
                    if (resp?.saveUrl) window.location.href = resp.saveUrl;
                  } catch (e) {
                    setWalletError(e.message || t('public.claim.walletError'));
                  } finally {
                    setSavingWallet(false);
                  }
                }}
              >
                {t('public.claim.addToGoogleWallet')}
              </button>
              {walletError && <div className="text-[11px] text-red-600 mt-1">{walletError}</div>}
            </div>
            <p className="text-[10px] text-muted-foreground">
              {t('public.claim.note')}
            </p>
          </>
        )}
      </div>
    </div>
  );
};
export default ClaimPage;
